module.exports = __webpack_public_path__ + "static/media/sf_attraction_14.0d194c36.jpg";